import React from "react";
import Notification from "@components/Notification";
import { useGlobalContext, useGlobalContextUpdate } from "@contexts/Global";

export const NotificationContainer = (props = {}) => {
  const globalContext = useGlobalContext();
  const setGlobalContext = useGlobalContextUpdate();
  const {
    notificationType = "",
    notificationMessage = "",
    showNotification = false,
  } = globalContext;

  const handleCloseNotification = () => {
    setGlobalContext({
      notificationType: "",
      notificationMessage: "",
      showNotification: false,
    });
  };

  const handleInstall = () => {
    props.onInstall();
    handleCloseNotification();
  }

  return (
    <Notification
      open={showNotification}
      type={notificationType}
      message={notificationMessage}
      onClose={handleCloseNotification}
      onInstall={handleInstall} 
    />
  );
};
